module.exports = __webpack_public_path__ + "img/SET-m.5f55254a.png";